/**
 * Переключатель текущего города для пользователя
 *
 * @param {Object} params
 * @param {String} params.citySelect - селект города
 * @param {String} params.activeCity - селект выбранного города
 * @param {String} params.cityCookie - кука города
 * @param {Number} params.foreverTimeCookie - время для бесконечного сохранения куки
 */
$.fn.citySwitcher = function (params) {

    const $self = $(this);
    const $select = $self.find('select');
    const $selectHolder = $self.find('.js-select-holder');
    const cityCookie = params.cityCookie;
    const foreverTimeCookie = params.foreverTimeCookie;
    let $customSelectInstance;

    const initCustomSelect = () => {
        $customSelectInstance = $select.select2({
            containerCss: {
                'width': 'auto'
            },
            containerCssClass: 'c-select',
            minimumResultsForSearch: -1,
            dropdownParent: $selectHolder,
            placeholder: {
                id: '-1',
                text: 'Москве'
            }
        });
    };

    initCustomSelect();

    /**
     * Нажатие на выбранный город в переключателе
     */
    $select.on('select2:select', function (e) {
        const cityId = $select.find(':selected').val();
        setCookie(cityCookie, cityId, {expires: foreverTimeCookie});
        document.location.reload();
    });

    return this;
};

// инициализация
const init = function () {
    $('#city-switcher').citySwitcher({
        cityCookie: 'city_switcher_active_city',
        foreverTimeCookie: 3600 * 24 * 30 * 12 * 5
    });
};

if ($('#city-switcher').length > 0) {
    init();
}
